import { CaretLeftIcon, XIcon } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import settings from "./settings";

const CartHeader = ({ count = 0, onEmptyCart, safeArea }) => {
  const navigate = useNavigate();

  // Settings'ten değerleri al
  const backgroundColor = settings.backgroundColor.value;
  const textColor = settings.textColor.value;
  const iconColor = settings.iconColor.value;
  const borderColor = settings.borderColor.value;
  const buttonHoverColor = settings.buttonHoverColor.value;
  const paddingX = settings.paddingX.value + "px";
  const paddingY = settings.paddingY.value + "px";
  const safeAreaOffset = settings.safeAreaOffset.value;
  const titleFontSize = settings.titleFontSize.value + "px";
  const titleFontWeight = settings.titleFontWeight.value;
  const iconSize = settings.iconSize.value;
  const buttonSize = settings.buttonSize.value + "px";
  const buttonBorderRadius = settings.buttonBorderRadius.value + "px";
  const emptyButtonBorderRadius =
    settings.emptyButtonBorderRadius.value === 9999
      ? "9999px"
      : settings.emptyButtonBorderRadius.value + "px";
  const borderWidth = settings.borderWidth.value + "px";
  const itemsGap = settings.itemsGap.value + "px";
  const titleLeftMargin = settings.titleLeftMargin.value + "px";
  const showBorder = settings.showBorder.value;
  const showBackButton = settings.showBackButton.value;
  const showEmptyButton = settings.showEmptyButton.value;
  const showItemCount = settings.showItemCount.value;
  const title = settings.title.value;
  const emptyButtonAriaLabel = settings.emptyButtonAriaLabel.value;
  const backButtonAriaLabel = settings.backButtonAriaLabel.value;

  const onBackClick = () => {
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  const getCountText = () => {
    if (!showItemCount || count === 0) return "";
    return ` (${count} ürün${count > 1 ? "" : ""})`;
  };

  return (
    <div
      style={{
        paddingTop: (safeArea?.top || 0) + safeAreaOffset + "px",
        display: "flex",
        alignItems: "center",
        paddingLeft: paddingX,
        paddingRight: paddingX,
        paddingBottom: paddingY,
        gap: itemsGap,
        backgroundColor: backgroundColor,
        borderBottom: showBorder
          ? `${borderWidth} solid ${borderColor}`
          : "none",
      }}
    >
      {/* Back button */}
      {showBackButton && (
        <button
          onClick={onBackClick}
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: buttonSize,
            height: buttonSize,
            borderRadius: buttonBorderRadius,
            border: "none",
            backgroundColor: "transparent",
            transition: "background-color 0.15s ease",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = buttonHoverColor;
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "transparent";
          }}
          aria-label={backButtonAriaLabel}
        >
          <CaretLeftIcon
            weight="bold"
            width={iconSize}
            height={iconSize}
            color={iconColor}
          />
        </button>
      )}

      {/* Title */}
      <h2
        style={{
          fontSize: titleFontSize,
          fontWeight: titleFontWeight,
          color: textColor,
          marginLeft: showBackButton ? titleLeftMargin : "0",
          margin: 0,
        }}
      >
        {title}
        {getCountText()}
      </h2>

      {/* Empty Cart button */}
      {showEmptyButton && (
        <button
          onClick={onEmptyCart}
          style={{
            padding: "8px",
            color: iconColor,
            border: "none",
            backgroundColor: "transparent",
            borderRadius: emptyButtonBorderRadius,
            flexShrink: 0,
            marginLeft: "auto",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "background-color 0.15s ease",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = buttonHoverColor;
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "transparent";
          }}
          aria-label={emptyButtonAriaLabel}
        >
          <span style={{ lineHeight: "0" }}>
            <XIcon width={iconSize} height={iconSize} color={iconColor} />
          </span>
        </button>
      )}
    </div>
  );
};

export default CartHeader;
